module.exports = __webpack_public_path__ + "blissweb-bd.c252c7cf2862023e7857.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Bd/blissweb-bd.woff
// module id = 475
// module chunks = 5